import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class FilesValidator {
  /**
   * Validates if the value of the control that is a File has on of the extensions provided in the string
   * @author Mateusz Warzyc
   * @param acceptedExtensions for example: '.png, .jpg, .jpeg, .pdf'
   */
  static validateFileExtension(acceptedExtensions: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!!control.value && control.value instanceof File && !!acceptedExtensions && acceptedExtensions.length > 0) {
        const extension = control.value.name.split(".").pop();
        if (!extension || acceptedExtensions?.toLowerCase().includes(extension?.toLowerCase())) {
          return null;
        } else {
          return { notSupportedType: { current: extension, accepted: acceptedExtensions } };
        }
      }
      return null;
    };
  }

  /**
   * Validates if the value of the control that is a File has the extension provided in the string
   * @author Mateusz Warzyc
   * @param requiredExtension for example: '.png'
   */
  static validateIfExtensionTheSame(requiredExtension: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!!control.value && control.value instanceof File) {
        const extension = control.value.name.split(".").pop();
        if (
          !extension ||
          extension.toLowerCase() === requiredExtension.toLowerCase() ||
          `.${extension.toLowerCase()}` === requiredExtension.toLowerCase()
        ) {
          return null;
        } else {
          return { noTheSameExtension: requiredExtension };
        }
      }
      return null;
    };
  }

  /**
   * Validates if the value of the control that is a File has less than megabytes.
   *
   * @author Mateusz Warzyc
   * @param maxSizeInMB number of megabytes.
   */
  static validateFileSize(maxSizeInMB: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!!control.value && control.value instanceof File) {
        const bytesPerMB: number = 1024 * 1024;
        const maxFileSizeInBytes = maxSizeInMB * bytesPerMB;
        if (control.value.size > maxFileSizeInBytes) {
          return { fileIsTooBig: { maxSizeInMB: `${maxSizeInMB} MB` } };
        }
      }
      return null;
    };
  }
}
